module.exports = __webpack_public_path__ + "img/bintang.white.a19a7ad5.svg";